import { render, staticRenderFns } from "./OriginFromLocal.vue?vue&type=template&id=50c961c0&scoped=true&"
import script from "./OriginFromLocal.vue?vue&type=script&lang=js&"
export * from "./OriginFromLocal.vue?vue&type=script&lang=js&"
import style0 from "./OriginFromLocal.vue?vue&type=style&index=0&id=50c961c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c961c0",
  null
  
)

export default component.exports